export type NewsCategory =
  | "活动报道"
  | "采访专访"
  | "作品发布"
  | "荣誉奖项"
  | "幕后花絮";

export interface NewsItem {
  id: string;
  title: string;
  category: NewsCategory;
  date: string;
  author: string;
  summary: string;
  cover: string;
  views: number;
  content: string[];
}

export const newsCategories: NewsCategory[] = [
  "活动报道",
  "采访专访",
  "作品发布",
  "荣誉奖项",
  "幕后花絮",
];

export const newsList: NewsItem[] = [
  {
    id: "n1",
    title: "白石茉莉奈亮相年度影视盛典，斩获「年度人气女演员」大奖",
    category: "荣誉奖项",
    date: "2026-10-08",
    author: "编辑部 · 林深",
    summary:
      "在刚刚落幕的年度影视盛典上，白石茉莉奈凭借过去一年稳定的表现与超高人气，获得「年度人气女演员」奖项，并发表真挚感言。",
    cover:
      "https://readdy.ai/api/search-image?query=Elegant%20film%20festival%20stage%20with%20warm%20spotlight%20and%20golden%20confetti%2C%20sophisticated%20purple%20and%20orange%20stage%20lighting%2C%20abstract%20cinematic%20ceremony%20atmosphere%2C%20soft%20bokeh%20background&width=800&height=450&seq=news-award-2026&orientation=landscape",
    views: 12840,
    content: [
      "在刚刚落幕的年度影视盛典上，白石茉莉奈身着一袭深紫色长裙亮相红毯，成为当晚最受关注的焦点之一。凭借过去一年在影视作品中的稳定发挥与持续攀升的人气，她最终摘得「年度人气女演员」殊荣。",
      "登台领奖时，白石茉莉奈坦言这份荣誉对自己意义重大：「非常感谢每一位支持我的朋友，是你们让我有勇气不断挑战新的角色。演员这条路很长，我会继续保持初心，把每一个角色都演好。」",
      "据悉，本次盛典由业内多家媒体联合主办，评审维度涵盖作品口碑、观众投票与行业评价。白石茉莉奈在观众投票环节始终稳居前列，最终以综合评分第一的成绩获奖。",
      "获奖之后，她也在社交平台发布长文致谢，并透露下一阶段将尝试更具挑战性的角色类型，希望给观众带来新的惊喜。",
    ],
  },
  {
    id: "n2",
    title: "深度专访：白石茉莉奈谈表演——「我想演一个普通人」",
    category: "采访专访",
    date: "2026-10-02",
    author: "特约撰稿 · 苏晚",
    summary:
      "在本期深度专访中，白石茉莉奈聊到了她对表演的理解、对角色选择的坚持，以及聚光灯之外那个喜欢安静阅读的自己。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimalist%20studio%20interview%20set%20with%20soft%20warm%20lighting%2C%20muted%20purple%20backdrop%20curtain%2C%20elegant%20editorial%20portrait%20atmosphere%2C%20blurred%20foreground%20plant%2C%20calm%20sophisticated%20tone&width=800&height=450&seq=news-interview-2026&orientation=landscape",
    views: 9820,
    content: [
      "「其实比起被称作明星，我更希望大家记住我演过的角色。」坐在采访间里的白石茉莉奈语气轻松。这一天她没有浓妆，素净的衬衫配长裤，和镜头前那个光鲜的形象判若两人。",
      "谈到对表演的理解，她表示自己越来越迷恋「日常感」：「我想演一个普通人。没有跌宕起伏的剧情，就是上班、回家、和家人吃饭，但那种生活里细小的情绪，反而最难演。」",
      "对于外界常常讨论的「转型」话题，她显得很坦然：「转型这个词有点重。我只是想多试一点不一样的东西，哪怕是配角，只要角色有意思，我都愿意。」",
      "采访最后，她分享了自己的日常：不工作的时候喜欢看书、煮咖啡、散步。「安静的时间很重要，它让我重新变得敏感，也让我更懂角色。」",
    ],
  },
  {
    id: "n3",
    title: "新剧《雾港来信》定档，白石茉莉奈挑战温柔母亲角色",
    category: "作品发布",
    date: "2026-09-26",
    author: "编辑部 · 陈屿",
    summary:
      "由白石茉莉奈主演的都市情感剧《雾港来信》正式官宣定档，此次她一改往日形象，饰演一位在生活与事业间寻找平衡的年轻母亲。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20misty%20harbor%20town%20at%20dusk%2C%20soft%20blue%20purple%20haze%2C%20distant%20warm%20orange%20street%20lamps%2C%20cinematic%20atmospheric%20landscape%2C%20melancholic%20calm%20mood%2C%20subtle%20film%20grain&width=800&height=450&seq=news-drama-2026&orientation=landscape",
    views: 7650,
    content: [
      "都市情感剧《雾港来信》于今日正式官宣定档。该剧以一座临海小城为背景，讲述几段关于亲情、离别与重逢的故事。白石茉莉奈在剧中饰演女主角「林素」，一位在生活压力与自我追求之间不断寻找平衡的年轻母亲。",
      "制片方表示，选择白石茉莉奈是因为她身上有种「温柔而坚韧」的气质，与角色高度契合。「试镜的时候，她一个很小的眼神，我们就知道找对人了。」",
      "为了更贴近角色，白石茉莉奈提前一个月跟随剧组到海边小城体验生活，学习当地的方言与生活习惯。她笑称：「这次是真的把自己晒黑了不少。」",
      "《雾港来信》预计将于本季度末与观众见面，具体播出时间将通过官方渠道陆续公布。",
    ],
  },
  {
    id: "n4",
    title: "公益行：白石茉莉奈探访儿童艺术课堂，陪伴是最好的礼物",
    category: "活动报道",
    date: "2026-09-18",
    author: "编辑部 · 何一",
    summary:
      "上周，白石茉莉奈低调现身一场儿童艺术公益活动，与孩子们一起画画、读书，用一下午的陪伴传递温暖。",
    cover:
      "https://readdy.ai/api/search-image?query=Bright%20airy%20children%20art%20classroom%20with%20colorful%20drawings%20on%20wall%2C%20warm%20natural%20sunlight%2C%20wooden%20desks%20with%20painting%20supplies%2C%20cozy%20hopeful%20atmosphere%2C%20soft%20pastel%20tones&width=800&height=450&seq=news-charity-2026&orientation=landscape",
    views: 6120,
    content: [
      "没有媒体通告，也没有铺天盖地的宣传，白石茉莉奈在一场儿童艺术公益活动中低调现身。她穿着简单的白衬衫，和孩子们围坐在桌前，一起涂涂画画。",
      "活动现场，她陪孩子们读绘本、折纸、画画，耐心地听每一个孩子讲自己的小故事。「他们画的东西特别有想象力，反而是我被治愈了。」她这样说。",
      "主办方介绍，这批儿童艺术作品后续将进行公益展出，所得善款将用于支持偏远地区的美育课程。「希望能有更多人关注到孩子们的艺术梦想。」白石茉莉奈在活动尾声说道。",
      "这并非她第一次参与公益。据工作人员透露，她多年来持续关注儿童美育方向，更愿意「安静地做事，不打扰孩子」。",
    ],
  },
  {
    id: "n5",
    title: "幕后花絮：一场夜戏连拍十二条，白石茉莉奈敬业获赞",
    category: "幕后花絮",
    date: "2026-09-10",
    author: "现场记录 · 周舟",
    summary:
      "新作拍摄现场的一组花絮曝光，白石茉莉奈为了一场雨夜戏连续拍摄十二条，直到导演满意为止，敬业态度获剧组一致点赞。",
    cover:
      "https://readdy.ai/api/search-image?query=Rainy%20night%20film%20set%20with%20soft%20blue%20and%20orange%20location%20lights%2C%20wet%20reflective%20street%2C%20cinematic%20behind%20the%20scenes%20atmosphere%2C%20moody%20purple%20sky%2C%20shallow%20depth%20of%20field&width=800&height=450&seq=news-bts-2026&orientation=landscape",
    views: 5430,
    content: [
      "近日，一组新作拍摄现场的花絮照片在网络流传。画面中，白石茉莉奈身着薄外套站在人工雨中，为一场关键的夜戏反复走位。",
      "据现场工作人员透露，这场戏因为涉及雨水与灯光的配合，拍摄难度很高，「她连着拍了十二条，中间没有一句抱怨，反而是她一直在安慰紧张的新人演员。」",
      "导演在采访中也对这段戏印象深刻：「她不是一个只完成动作的演员，她会去想角色此刻在想什么。那种专注非常打动人。」",
      "拍摄结束后，白石茉莉奈只是简单喝了杯姜茶，笑着对大家说「辛苦了」。这条花絮也让不少网友留言：「认真的人最有魅力。」",
    ],
  },
  {
    id: "n6",
    title: "《静水流深》口碑走高，白石茉莉奈文艺片首秀获业内好评",
    category: "作品发布",
    date: "2026-08-30",
    author: "影评 · 顾青",
    summary:
      "文艺电影《静水流深》上映两周口碑持续走高，白石茉莉奈在片中的克制表演被多位影评人称为「惊喜」。",
    cover:
      "https://readdy.ai/api/search-image?query=Serene%20riverside%20landscape%20at%20golden%20hour%2C%20quiet%20water%20reflecting%20soft%20purple%20sky%2C%20minimal%20artistic%20composition%2C%20calm%20meditative%20mood%2C%20subtle%20warm%20orange%20light&width=800&height=450&seq=news-artfilm-2026&orientation=landscape",
    views: 4980,
    content: [
      "文艺电影《静水流深》上映两周以来，凭借细腻的叙事与克制的镜头语言，收获了不少观众的喜爱。其中，白石茉莉奈的表演成为讨论度最高的话题之一。",
      "在片中，她饰演一位回到故乡处理旧事的女子，全片台词不多，情绪大多依靠眼神与微表情传递。有影评人评价：「她的表演是收着的，但你能感觉到水面之下的汹涌。」",
      "面对好评，白石茉莉奈在采访中显得很平静：「这是我第一次演这么安静的戏，一开始还担心自己撑不起来。后来想通了，就把自己交出去，相信导演。」",
      "据悉，《静水流深》后续还将在多个城市进行艺术院线专场放映。",
    ],
  },
  {
    id: "n7",
    title: "白石茉莉奈出席品牌活动，简约造型演绎高级质感",
    category: "活动报道",
    date: "2026-08-22",
    author: "时尚组 · 沈依",
    summary:
      "在一场高端品牌活动上，白石茉莉奈以极简深色造型亮相，被现场媒体评为当晚「最佳着装」之一。",
    cover:
      "https://readdy.ai/api/search-image?query=High%20end%20brand%20event%20venue%20with%20minimal%20purple%20and%20warm%20amber%20ambient%20lighting%2C%20elegant%20sleek%20interior%2C%20sophisticated%20luxury%20atmosphere%2C%20soft%20glow%20abstract%20background&width=800&height=450&seq=news-brand-2026&orientation=landscape",
    views: 4310,
    content: [
      "在一场高端品牌活动上，白石茉莉奈以一身极简深色礼服亮相，没有繁复的配饰，却凭借干净利落的剪裁与沉稳气场，成为当晚媒体镜头追逐的对象。",
      "谈及自己的穿搭理念，她表示：「我越来越喜欢简单的东西，越简单越考验质感。衣服是为人服务的，不应该是人被衣服压住。」",
      "现场她与品牌主理人进行了简短交流，并参观了当季新品陈列。不少在场记者评价，她的造型「高级但不疏离，很有分寸感」。",
      "活动结束后，她当晚的造型图迅速登上社交平台热搜讨论区。",
    ],
  },
  {
    id: "n8",
    title: "专访幕后团队：为什么说白石茉莉奈是「最省心的演员」",
    category: "采访专访",
    date: "2026-08-14",
    author: "特约撰稿 · 苏晚",
    summary:
      "从一个剧组团队的视角，看白石茉莉奈为什么会被反复邀请合作——专业、准时、状态稳定，是最高频的关键词。",
    cover:
      "https://readdy.ai/api/search-image?query=Empty%20professional%20film%20production%20office%20with%20storyboards%20and%20schedules%20on%20wall%2C%20warm%20desk%20lamp%20light%2C%20neat%20organized%20creative%20workspace%2C%20calm%20neutral%20tones&width=800&height=450&seq=news-team-2026&orientation=landscape",
    views: 3870,
    content: [
      "这一次我们把镜头对准剧组。几位与白石茉莉奈合作过的工作人员给出了几乎一致的评价：专业、准时、状态稳定。",
      "一位副导演说：「她进组第一天就把所有场次的剧本都圈好了，连工作人员的名字都记得住。这种细节，会让整个组的氛围变好。」",
      "化妆师则提到，她很少对造型提额外要求，「她更关心的是这个造型符不符合角色，而不是好不好看。」",
      "在被问及「最省心的演员」这个说法时，白石茉莉奈本人笑着摆手：「我只是觉得，大家都不容易，把工作做好是最基本的尊重。」",
    ],
  },
  {
    id: "n9",
    title: "白石茉莉奈官宣全新代言，携手诠释「沉静力量」",
    category: "作品发布",
    date: "2026-08-05",
    author: "品牌组 · 陆行",
    summary:
      "白石茉莉奈正式成为某高端生活方式品牌代言人，广告主题片以「沉静力量」为概念，展现她安静而有力量的一面。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimalist%20beige%20studio%20with%20soft%20directional%20light%20and%20long%20soft%20shadow%2C%20elegant%20product%20pedestal%2C%20quiet%20premium%20editorial%20atmosphere%2C%20warm%20neutral%20palette&width=800&height=450&seq=news-endorse-2026&orientation=landscape",
    views: 3560,
    content: [
      "白石茉莉奈正式成为某高端生活方式品牌的全新代言人。品牌方表示，选择她是因为她身上兼具「安静」与「力量」两种气质，与品牌理念高度一致。",
      "同步发布的概念主题片以「沉静力量」为名，全片没有一句台词，通过光影与呼吸感的镜头，呈现她安静却笃定的一面。",
      "对于这次合作，白石茉莉奈表示：「我很喜欢这个概念。安静不等于软弱，很多时候，安静是一种更坚定的力量。」",
      "主题片上线后，短时间内即获得大量转发，不少网友评论「很符合她给人的感觉」。",
    ],
  },
  {
    id: "n10",
    title: "粉丝见面会温暖收官，白石茉莉奈手写回信感动全场",
    category: "活动报道",
    date: "2026-07-28",
    author: "编辑部 · 何一",
    summary:
      "一场线下粉丝见面会顺利收官，白石茉莉奈现场朗读了自己写给粉丝的手写信，真挚内容让不少观众红了眼眶。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20cozy%20indoor%20event%20hall%20with%20soft%20string%20lights%20and%20purple%20ambient%20glow%2C%20rows%20of%20empty%20seats%20before%20a%20small%20stage%2C%20intimate%20heartfelt%20atmosphere&width=800&height=450&seq=news-fanmeeting-2026&orientation=landscape",
    views: 5240,
    content: [
      "在一场线下粉丝见面会上，白石茉莉奈没有准备华丽的节目单，而是选择在最后环节，现场朗读了一封自己手写的信。",
      "「我不知道该怎么回报你们的喜欢，只能努力成为一个值得被喜欢的人。」读到这句话时，台下不少观众红了眼眶，她也一度停顿。",
      "活动设置了互动问答与合影环节，她几乎记住了每位提问粉丝的名字。有粉丝表示：「喜欢她这么多年，从来没有后悔过。」",
      "见面会结束后，团队透露后续会考虑更多不同城市的小型见面活动，希望离大家更近一点。",
    ],
  },
  {
    id: "n11",
    title: "行业观察：白石茉莉奈的「慢」路线为何越来越受欢迎",
    category: "采访专访",
    date: "2026-07-15",
    author: "行业观察 · 顾青",
    summary:
      "在流量快速更迭的行业里，白石茉莉奈选择了一条「慢」的路线。本文试着分析，这份慢，为什么反而更被看见。",
    cover:
      "https://readdy.ai/api/search-image?query=Abstract%20conceptual%20image%20of%20slow%20steady%20growth%2C%20minimal%20geometric%20shapes%20in%20deep%20purple%20and%20warm%20orange%2C%20clean%20editorial%20composition%2C%20calm%20thoughtful%20tone&width=800&height=450&seq=news-analysis-2026&orientation=landscape",
    views: 2980,
    content: [
      "在流量快速更迭的当下，很多演员选择高频曝光，而白石茉莉奈却显得格外「慢」——接戏不多，宣传克制，却始终稳定地被观众记住。",
      "分析她近几年的作品路线可以发现，她更倾向于选择有表达空间、能挑战自我的角色，而非单纯的流量项目。这种取舍，短期内或许不够「亮眼」，却在长期积累了口碑。",
      "一位业内人士评价：「她不是那种一夜爆红的类型，但她的作品经得起回看。这在今天的行业里其实很稀缺。」",
      "慢，不代表停滞。可以预见，只要这份对作品的认真还在，她的路会越走越稳。",
    ],
  },
  {
    id: "n12",
    title: "《潮汐之上》预告发布，白石茉莉奈诠释坚韧女性群像",
    category: "作品发布",
    date: "2026-07-03",
    author: "编辑部 · 陈屿",
    summary:
      "聚焦女性成长的剧集《潮汐之上》发布首支预告，白石茉莉奈在片中饰演一位在逆境中重新站起来的女性创业者。",
    cover:
      "https://readdy.ai/api/search-image?query=Dramatic%20ocean%20waves%20at%20dusk%20with%20deep%20purple%20and%20orange%20sky%2C%20cinematic%20powerful%20seascape%2C%20moody%20atmospheric%20horizon%2C%20subtle%20film%20texture&width=800&height=450&seq=news-tide-2026&orientation=landscape",
    views: 6120,
    content: [
      "聚焦女性成长与选择的剧集《潮汐之上》正式发布首支预告片。白石茉莉奈在剧中饰演一位在事业低谷后重新出发的女性创业者。",
      "从预告片段来看，角色经历了从迷茫、挣扎到重新站稳的全过程。白石茉莉奈的表演层次分明，几段无声的哭戏尤其有感染力。",
      "谈及角色，她表示：「她不是完美的女强人，她会怕、会退缩，但最后还是选择站起来。我很喜欢这种真实。」",
      "《潮汐之上》预计将于年内与观众见面，后续宣发信息将由官方陆续公布。",
    ],
  },
];